import React, { Component } from "react";
import IqacDescription from "./IqacDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const NAVY    = "#1A2B4A";
const NAVY_2  = "#243B66";
const GOLD    = "#C8991A";
const CRIMSON = "#B22222";
const INK     = "#374151";
const MUTED   = "#6b7280";
const BORDER  = "#e8e0d0";
const SURFACE = "#f7f6f2";

const list = [
  { title: "About", link: "/iqac/about" },
  { title: "IQAC Core Committees", link: "/iqac/core-committes" },
  { title: "IIQA", link: "/iqac/iiqa" },
  { title: "SSR", link: "/iqac/ssr" },
  { title: "SSR NAAC Matrices", link: "/iqac/ssrmatrix" },
  { title: "DVV", link: "/iqac/dvv" },
  { title: "AQAR", link: "/iqac/aqar" },
  { title: "AQAR NAAC Matrices", link: "/iqac/matrix" },
  { title: "Institutional Development Plan", link: "/iqac/idp" },
  { title: "Committees", link: "/iqac/units-and-wings" },
  { title: "AISHE Data", link: "/iqac/aishe-data" },
  { title: "Student Satisfactory Survey", link: "/iqac/sss" },
  { title: "Action Plan", link: "/iqac/actionplan" },
  {
    title: "Reports",
    link: "##123",
    subLink: [
      { title: "Annual Report", link: "/iqac/annual-report" },
      { title: "Audit Report", link: "/iqac/auditreport" },
    ],
  },
  {
    title: "Events and Meetings",
    link: "##125",
    subLink: [
      { title: "Minutes & Resolutions", link: "/iqac/minutes" },
      { title: "IQAC Event", link: "/iqac/event-news" },
    ],
  },
  { title: "Best Practice", link: "/iqac/best-practice" },
  { title: "Academic Calendar", link: "/iqac/academic-calendar" },
  {
    title: "Feedbacks",
    link: "##124",
    subLink: [
      { title: "Feedback Forms", link: "/iqac/feedback" },
      { title: "Feedback Analysis", link: "/iqac/feedback-analysis" },
    ],
  },
  { title: "MoUs & Collaborations", link: "/iqac/mou-collaborations" },
  { title: "Handbook & Policy Documents", link: "/iqac/handbook" },
  { title: "Dept. Advisory Committee", link: "/iqac/dac" },
  { title: "Satff Duty Fragmentation", link: "/iqac/sdf" },
  { title: "Codes, Guidelines & Circulars", link: "/iqac/cgc" },
  { title: "Organogram", link: "/iqac/organogram" },
  { title: "Institutional Distinctiveness", link: "/iqac/institutional-distingtiveness" },
  { title: "COs & POs", link: "/iqac/co_po" },
  { title: "NIRF", link: "/iqac/nirf" },
  { title: "DVV (Archives)", link: "/iqac/dvv-archives" },
];

const ChevronIcon = ({ open }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    style={{
      transition: "transform 0.2s ease",
      transform: open ? "rotate(180deg)" : "rotate(0deg)",
      opacity: 0.7,
      flexShrink: 0,
    }}
  >
    <path d="M7 10l5 5 5-5z" />
  </svg>
);

class IqacComponent extends Component {
  state = {
    link: "",
    openGroups: {},
  };

  componentDidMount() {
    const link = this.props.match.params.link;
    this.setState({
      link,
      openGroups: this.computeOpenGroups(link),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.link !== this.props.match.params.link) {
      const link = this.props.match.params.link;
      this.setState((s) => ({
        link,
        openGroups: { ...s.openGroups, ...this.computeOpenGroups(link) },
      }));
    }
  }

  computeOpenGroups = (link) => {
    const path = `/iqac/${link}`;
    const open = {};
    list.forEach((el, i) => {
      if (el.subLink && el.subLink.some((s) => s.link === path)) {
        open[i] = true;
      }
    });
    return open;
  };

  isActive = (path) => path === `/iqac/${this.state.link}`;

  toggleGroup = (index) => {
    this.setState((s) => ({
      openGroups: { ...s.openGroups, [index]: !s.openGroups[index] },
    }));
  };

  go = (path) => {
    this.props.history.push(path);
  };

  render() {
    return (
      <div>
        <BreadCrumbOwn title="IQAC" />

        <div className="iqac-page">
          <div className="iqac-page__inner">
            {/* SIDEBAR */}
            <aside className="iqac-side">
              <div className="iqac-side__header">
                <span className="iqac-side__eyebrow">Internal Quality</span>
                <span className="iqac-side__title">IQAC Navigation</span>
              </div>

              <nav className="iqac-side__nav" aria-label="IQAC sections">
                {list.map((el, index) => {
                  const hasSub = el.subLink && el.subLink.length > 0;
                  if (hasSub) {
                    const open = !!this.state.openGroups[index];
                    const groupActive = el.subLink.some((s) =>
                      this.isActive(s.link)
                    );
                    return (
                      <div key={index} className="iqac-side__group">
                        <button
                          type="button"
                          className={`iqac-side__item iqac-side__item--group${
                            groupActive ? " is-parent-active" : ""
                          }`}
                          onClick={() => this.toggleGroup(index)}
                          aria-expanded={open}
                        >
                          <span>{el.title}</span>
                          <ChevronIcon open={open} />
                        </button>
                        {open && (
                          <div className="iqac-side__submenu">
                            {el.subLink.map((sub, j) => {
                              const active = this.isActive(sub.link);
                              return (
                                <button
                                  type="button"
                                  key={j}
                                  onClick={() => this.go(sub.link)}
                                  className={`iqac-side__subitem${
                                    active ? " is-active" : ""
                                  }`}
                                >
                                  <span className="iqac-side__bullet" />
                                  {sub.title}
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }

                  const active = this.isActive(el.link);
                  return (
                    <button
                      type="button"
                      key={index}
                      onClick={() => this.go(el.link)}
                      className={`iqac-side__item${active ? " is-active" : ""}`}
                    >
                      <span>{el.title}</span>
                    </button>
                  );
                })}
              </nav>
            </aside>

            {/* CONTENT */}
            <main className="iqac-content">
              <div className="iqac-content__body">
                <IqacDescription type={this.state.link} />
              </div>
            </main>
          </div>
        </div>

        <style>{`
          .iqac-page {
            background: #fff;
            padding: 32px 0 56px;
          }
          .iqac-page__inner {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            display: grid;
            grid-template-columns: 280px 1fr;
            gap: 28px;
            align-items: start;
          }

          /* ── Sidebar ── */
          .iqac-side {
            background: #fff;
            border: 1px solid ${BORDER};
            border-radius: 10px;
            box-shadow: 0 4px 18px rgba(26,43,74,0.06);
            overflow: hidden;
            position: sticky;
            top: 16px;
            max-height: calc(100vh - 32px);
            display: flex;
            flex-direction: column;
            font-family: 'Lato', sans-serif;
          }
          .iqac-side__header {
            background: linear-gradient(135deg, ${NAVY} 0%, ${NAVY_2} 100%);
            color: #fff;
            padding: 18px 20px 16px;
            border-bottom: 3px solid ${GOLD};
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          .iqac-side__eyebrow {
            color: ${GOLD};
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
          }
          .iqac-side__title {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: 0.3px;
          }
          .iqac-side__nav {
            overflow-y: auto;
            padding: 6px 0;
            scrollbar-width: thin;
            scrollbar-color: ${GOLD} transparent;
          }
          .iqac-side__nav::-webkit-scrollbar { width: 6px; }
          .iqac-side__nav::-webkit-scrollbar-thumb {
            background: rgba(200,153,26,0.4);
            border-radius: 3px;
          }
          .iqac-side__item {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            border-left: 3px solid transparent;
            padding: 10px 16px 10px 18px;
            font-family: 'Lato', sans-serif;
            font-size: 13.5px;
            font-weight: 500;
            color: ${INK};
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            transition: background 0.15s, color 0.15s, border-color 0.15s;
            line-height: 1.35;
          }
          .iqac-side__item:hover {
            background: rgba(200,153,26,0.08);
            color: ${NAVY};
            border-left-color: ${GOLD};
          }
          .iqac-side__item.is-active {
            background: rgba(178,34,34,0.06);
            color: ${CRIMSON};
            border-left-color: ${CRIMSON};
            font-weight: 700;
          }
          .iqac-side__item.is-parent-active {
            color: ${NAVY};
            font-weight: 700;
          }
          .iqac-side__item--group {
            font-weight: 600;
          }
          .iqac-side__submenu {
            background: ${SURFACE};
            border-top: 1px solid ${BORDER};
            border-bottom: 1px solid ${BORDER};
            padding: 4px 0;
          }
          .iqac-side__subitem {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            padding: 8px 16px 8px 36px;
            font-family: 'Lato', sans-serif;
            font-size: 12.5px;
            color: ${MUTED};
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 10px;
            transition: color 0.15s, background 0.15s, padding-left 0.15s;
          }
          .iqac-side__subitem:hover {
            color: ${NAVY};
            background: rgba(200,153,26,0.08);
            padding-left: 40px;
          }
          .iqac-side__subitem.is-active {
            color: ${CRIMSON};
            font-weight: 700;
            background: rgba(178,34,34,0.06);
          }
          .iqac-side__bullet {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: ${GOLD};
            flex-shrink: 0;
            display: inline-block;
          }
          .iqac-side__subitem.is-active .iqac-side__bullet {
            background: ${CRIMSON};
          }

          /* ── Content panel ── */
          .iqac-content {
            background: #fff;
            min-width: 0;
          }
          .iqac-content__body {
            padding: 8px 0 0 8px;
            color: ${INK};
            font-family: 'Lato', sans-serif;
          }

          @media (max-width: 960px) {
            .iqac-page__inner {
              grid-template-columns: 1fr;
            }
            .iqac-side {
              position: relative;
              top: 0;
              max-height: none;
            }
            .iqac-side__nav {
              max-height: 320px;
            }
            .iqac-content__body {
              padding: 8px 0 0 0;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default IqacComponent;
